export type MonthNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type MonthDropdownOption = {value: MonthNumber; label: string};

export const monthOptions: MonthDropdownOption[] = [
  {value: 1, label: 'Januari'},
  {value: 2, label: 'Februari'},
  {value: 3, label: 'Maart'},
  {value: 4, label: 'April'},
  {value: 5, label: 'Mei'},
  {value: 6, label: 'Juni'},
  {value: 7, label: 'Juli'},
  {value: 8, label: 'Augustus'},
  {value: 9, label: 'September'},
  {value: 10, label: 'Oktober'},
  {value: 11, label: 'November'},
  {value: 12, label: 'December'},
];
